export const defaultTheme = {
  name: "default",

  backgroundPrimary: "#ffffff",

  textPrimary: "#241E39",
  textSecondary: "#817d82",

  plain: "#FFFFFF",
  plainShadow: "#E7E4E7",
  plainDark: "#817D82",
  primary: "#F9C5F7",
  primaryShadow: "#DE9CDC",
  primaryDark: "#A1599F",
  secondary: "#FFEFC2",
  secondaryShadow: "#EBD493",
  secondaryDark: "#bd9c42",
  highlight: "#16899B",
  highlightShadow: "#1F4A51",
  danger: "#ef5252",
  dangerShadow: "#c23d3d",
};
